import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconExternalLink';
/** Renders an SVG icon. */
const SvgExternalLink = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M6 22V10a4 4 0 0 1 4-4h6a1 1 0 1 1 0 2h-6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a1 1 0 1 1 2 0v6a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4"
      />
      <path
        fill="currentColor"
        d="M26 11V7.414L15.707 17.707a1 1 0 1 1-1.414-1.414L24.586 6H21a1 1 0 1 1 0-2h6l.102.005A1 1 0 0 1 28 5v6a1 1 0 1 1-2 0"
      />
    </svg>
  );
};
SvgExternalLink.displayName = displayName;
export default SvgExternalLink;
